import { FC, PropsWithChildren } from 'react';

import { Flex, Text } from '@servicetitan/anvil2';

interface PageContentWrapperProps extends PropsWithChildren {
    title?: string;
}

export const PageContentWrapper: FC<PageContentWrapperProps> = ({ children, title }) => (
    <Flex direction="column" gap={4}>
        <Text variant="headline" el="h3" className="m-b-0-i">
            {title}
        </Text>
        {children}
    </Flex>
);
